import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import App from './App'

import Vue from 'vue'
import './uni.promisify.adaptor'
import uView from "uview-ui"
import store from './store/index.js'

Vue.config.productionTip = false

Vue.prototype.$baseUrl = 'http://192.168.0.126:10027/';
// Vue.prototype.$baseUrl = 'https://dmtest.ahapp.net/h5_api/';
Vue.prototype.$store = store;

App.mpType = 'app'

Vue.use(uView)

const app = new Vue({
	store,
  ...App
})

// http接口API抽离
import httpApi from '@/utils/http.api.js'
Vue.use(httpApi, app)

// 请求拦截器
import interceptor from '@/utils/http.interceptor.js'
Vue.use(interceptor, app)

app.$mount()